<app-section-grid [subSection]="'Create Pricing Plan'"></app-section-grid>

<app-stepper-grid></app-stepper-grid>

<div class="relative w-full max-w-4xl mx-auto p-10 bg-white rounded-3xl border border-gray-200 mb-5">

    <form [formGroup]="publisherCommercialModelForm" (ngSubmit)="onSubmit()">

        <!-- Header -->
        <div class="text-center mb-10">
            <h1 class="text-3xl font-bold text-gray-800 tracking-tight">
                Pricing Plan Details
            </h1>
            <p class="mt-2 text-gray-500">
                Enter the pricing plan details.
            </p>
        </div>

        <!-- Centered block -->
        <div class="w-full max-w-2xl mx-auto">

            <div class="grid grid-cols-12 gap-6">

                <!-- Change from Name to title -->
                <div class="col-span-12 lg:col-span-6">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        🏷 Title <small class="text-red-300">(required)</small> <!-- Updated label -->
                    </label>
                    <input type="text" formControlName="title" placeholder="Enter title..." class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
           focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors" />

                    <div *ngIf="publisherCommercialModelForm.get('title')?.touched && 
            publisherCommercialModelForm.get('title')?.hasError('required')" class="mt-1 text-xs text-red-500">
                        Title is required.
                    </div>
                </div>

                <!-- Date Range -->
                <div class="col-span-12 lg:col-span-6">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        📅 Start Date - End Date
                    </label>

                    <div class="flex items-center gap-2 border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50
                 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500
                 shadow-sm transition-colors">

                        <mat-date-range-input [rangePicker]="rangePicker" class="flex w-full gap-2">

                            <input matStartDate formControlName="start_date" placeholder="Start date"
                                class="bg-transparent outline-none w-full" />

                            <span class="text-gray-400">—</span>

                            <input matEndDate formControlName="end_date" placeholder="End date"
                                class="bg-transparent outline-none w-full" />

                        </mat-date-range-input>

                        <button type="button" (click)="rangePicker.open()"
                            class="text-gray-500 hover:text-blue-600 transition">
                            📆
                        </button>

                    </div>

                    <mat-date-range-picker #rangePicker>
                        <mat-date-range-picker-actions>
                            <button mat-button matDateRangePickerCancel>Cancel</button>
                            <button mat-raised-button matDateRangePickerApply>Apply</button>
                        </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                </div>

                <!-- Description -->
                <div class="col-span-12">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        📝 Description
                    </label>
                    <input type="text" formControlName="description" placeholder="Enter description..." class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors" />
                </div>

                <!-- Pricing Plan -->
                <div class="col-span-12 lg:col-span-6">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        💰 Pricing Plan <small class="text-red-300">(required)</small> <!-- Added required indicator -->
                    </label>
                    <select formControlName="pricing_plan_id" class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
           focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
                        <option value="">Select pricing plan...</option>
                        <option *ngFor="let pricingPlan of pricingPlans" [value]="pricingPlan.id">
                            {{ pricingPlan.title | titlecase}}
                        </option>
                    </select>

                    <!-- ✅ Add validation message -->
                    <div *ngIf="publisherCommercialModelForm.get('pricing_plan_id')?.touched && 
              publisherCommercialModelForm.get('pricing_plan_id')?.hasError('required')"
                        class="mt-1 text-xs text-red-500">
                        Pricing plan is required.
                    </div>
                </div>

                <!-- Month / Year -->
                <div class="col-span-12 lg:col-span-6">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        📆 Month / Year
                    </label>
                    <select formControlName="payment_type" class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
                        <option value="monthly">Monthly</option>
                        <option value="yearly">Yearly</option>
                    </select>
                </div>

            </div>

        </div>

        <app-submit-grid></app-submit-grid>

    </form>

</div>

<app-footer-grid></app-footer-grid>